module.exports = __webpack_public_path__ + "img/image-4.5c194e6d.jpg";